import { render, staticRenderFns } from "./TrackingCode.vue?vue&type=template&id=4648793b&scoped=true"
import script from "./TrackingCode.vue?vue&type=script&lang=js"
export * from "./TrackingCode.vue?vue&type=script&lang=js"
import style0 from "./TrackingCode.vue?vue&type=style&index=0&id=4648793b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648793b",
  null
  
)

export default component.exports